/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from 'ngx-bootstrap/modal/modal-backdrop.component';
const styles_ModalBackdropComponent:any[] = ([] as any[]);
export const RenderType_ModalBackdropComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_ModalBackdropComponent,data:{}});
export function View_ModalBackdropComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,([] as any[]),(null as any),(null as any));
}
export function View_ModalBackdropComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'bs-modal-backdrop',
      [['class','modal-backdrop']],(null as any),(null as any),(null as any),View_ModalBackdropComponent_0,
      RenderType_ModalBackdropComponent)),i0.ɵdid(1,114688,(null as any),0,i1.ModalBackdropComponent,
      [i0.ElementRef,i0.Renderer],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ModalBackdropComponentNgFactory:i0.ComponentFactory<i1.ModalBackdropComponent> = i0.ɵccf('bs-modal-backdrop',
    i1.ModalBackdropComponent,View_ModalBackdropComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL0NocmlzL0RvY3VtZW50cy9XZWJEZXYvRGV2R2VuQW5nL25vZGVfbW9kdWxlcy9uZ3gtYm9vdHN0cmFwL21vZGFsL21vZGFsLWJhY2tkcm9wLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9DaHJpcy9Eb2N1bWVudHMvV2ViRGV2L0RldkdlbkFuZy9ub2RlX21vZHVsZXMvbmd4LWJvb3RzdHJhcC9tb2RhbC9tb2RhbC1iYWNrZHJvcC5jb21wb25lbnQuZC50cyIsIm5nOi8vL1VzZXJzL0NocmlzL0RvY3VtZW50cy9XZWJEZXYvRGV2R2VuQW5nL25vZGVfbW9kdWxlcy9uZ3gtYm9vdHN0cmFwL21vZGFsL21vZGFsLWJhY2tkcm9wLmNvbXBvbmVudC5kLnRzLk1vZGFsQmFja2Ryb3BDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8YnMtbW9kYWwtYmFja2Ryb3A+PC9icy1tb2RhbC1iYWNrZHJvcD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO3VDQUFBLFVBQUE7TUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/node_modules/ngx-bootstrap/modal/modal-backdrop.component.ngfactory.ts